<div class="main-painel">
    <div class="title-panel">
        Consulta de Dados
    </div>
    <mat-divider></mat-divider>
    <div class="info">
        Buscar Dados de Tabelas do Banco de Dados da TemAPI
    </div>
    <mat-divider></mat-divider>
        <div class="more-options">
            <mat-slide-toggle  matTooltip="Opção selecionada fará com que o Request execute apenas um vez, dando a possibilidade de agrupar o resultado da Query em um único Array ( JSON/XML )" matTooltipClass="toolTip-request" [(ngModel)]="joinSql" [ngModelOptions]="{standalone: true}" (change)="onToggleChange('JOINSQL')" *ngIf="showJoinSql">Agrupar Consulta
            </mat-slide-toggle>
            <mat-divider [vertical]="true"></mat-divider>
            <mat-form-field [formGroup]="queryForm"  appearance="outline" class="no-padding-form-field-5px" *ngIf="showPackSize">
                <mat-label>Tamanho do Pacote</mat-label>
                <input  tabindex="1" type = "number" matInput formControlName="PACKSIZE" placeholder="Tamanho do Pacote de Requisição"   #inp  matTooltip="Ao informar esse campo, o sistema abrirá execuções simultâneas. Ex: Se informar 300 nesse campo e o resultado da query retorar 600 Linhas, serão abertas 2 execuções simultâneas, cada uma processando 300 linhas." matTooltipClass="toolTip-request"> 
                <button    tabindex="-1"   type="button" *ngIf="inp.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inp.value=''" >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    <mat-divider></mat-divider>

    <query-executor [query]="queryData" (queryChange)="onQueryChange($event)"></query-executor>
</div>